import React from 'react'
import AddAdmin from '../../components/superAdmin/admins/AddAdmin'

function AddAdminPage() {
  return (
    <div>
        <AddAdmin />
    </div>
  )
}

export default AddAdminPage